import { CustomButton } from '@/shared/ui/components';
import { useMarkAddressedStudy } from './useMarkAddressedStudy';
import MarkAddressedModal from './markAddressedModal';
import './markAddressedStudy.scss';

/**
 * Placeholder callback used as the default for optional handlers of the mark-addressed-study UI. Has an empty body and performs no work.
 *
 * @returns Nothing.
 */
const NOOP = () => {};

export interface MarkAddressedStudyProps {
  lastAddressedTime?: string;
  studyId: string;
  onUpdateMarkAddressed?: (isFailed?: boolean, id?: string) => void;
  resolvedAt?: string;
  isHideMarkAddressedStudy?: boolean;
}

const MarkAddressedStudy = ({
  lastAddressedTime = '',
  studyId,
  onUpdateMarkAddressed = NOOP,
  resolvedAt = '',
  isHideMarkAddressedStudy = false,
}: MarkAddressedStudyProps) => {
  const { isOpen, setIsOpen, loading, formatTime, onClickMarkAddressed } = useMarkAddressedStudy({
    lastAddressedTime,
    studyId,
    onUpdateMarkAddressed,
    resolvedAt,
    isHideMarkAddressedStudy,
  });

  return (
    <div className="mark-addressed-study-wrapper">
      {lastAddressedTime && (
        <div className="last-addressed">{` Last addressed: ${formatTime}`}</div>
      )}
      {!resolvedAt && !isHideMarkAddressedStudy && (
        <CustomButton onClick={() => setIsOpen(true)} size="small" type="outline">
          Mark as Addressed
        </CustomButton>
      )}
      <MarkAddressedModal
        loading={loading}
        onClickMarkAddressed={onClickMarkAddressed}
        isOpen={isOpen}
        onCloseModal={() => setIsOpen(false)}
      />
    </div>
  );
};

export default MarkAddressedStudy;
